'use strict';

const formValidation = require('../components/customFormValidation');

/**
 * IDでログインフォームを取得する
 *
 * @param {string} formID フォームID
 * @returns {object} form
 */
function getForm(formID) {
    const form = document.getElementById(formID);
    return form;
}

/**
 * XMLHttpRequest.send() メソッドを使用して簡単に送信できる、
 * フォーム フィールドとその値を表すキーと値のペアのセットを簡単に作成する方法を提供します。
 *
 * @param {object} form フォーム
 * @returns {object} formData
 */
function createFormData(form) {
    const formData = new FormData(form);
    return formData;
}

module.exports = {
    login: function () {
        const form = getForm('login-form');
        const $form = $(form);
        $form.on('submit', async (e) => {
            e.preventDefault();
            // 処理前にエラーメッセージを隠す
            $('.alert', '#form-error').remove();
            $.spinner().start();
            try {
                const url = $form.attr('action');
                const formData = createFormData(form);
                // フォームをAjaxでPOST送信する部品を用いる
                const postForm = require('sswd_base/components/XPostForm');
                const data = await postForm(url, formData);
                // --- レスポンスデータにredirectUrlが含まれる場合
                if (data.redirectUrl) {
                    // フォームをリセットする(ブラウザーバック時に値が復元されないようにする)
                    form.reset();
                    // redirectUrlに移動
                    window.location.href = data.redirectUrl;
                    return;
                }
                // --- レスポンスデータにredirectUrlが含まれない場合
                formValidation(form, data);
                // エラーを投げる
                throw new Error();
            } catch (err) {
                $.spinner().stop();
            }
        });
    },

    register: function () {
        const form = getForm('registration-form');
        const $form = $(form);
        $form.on('submit', async (e) => {
            e.preventDefault();
            // 処理前にエラーメッセージを隠す
            $('.alert', '#form-error').remove();
            $.spinner().start();
            try {
                const url = $form.attr('action');
                const formData = createFormData(form);
                // フォームをAjaxでPOST送信する部品を用いる
                const postForm = require('sswd_base/components/XPostForm');
                const data = await postForm(url, formData);
                // --- レスポンスデータにredirectUrlが含まれる場合
                if (data.redirectUrl) {
                    // フォームをリセットする(ブラウザーバック時に値が復元されないようにする)
                    form.reset();
                    // redirectUrlに移動
                    window.location.href = data.redirectUrl;
                    return;
                }
                // --- レスポンスデータにredirectUrlが含まれない場合
                formValidation(form, data);
                // エラーを投げる
                throw new Error();
            } catch (err) {
                $.spinner().stop();
            }
        });
    },

    eye: function () {
        $(function () {
            let currentEye = document.getElementById('current_eye');
            if (currentEye) {
                currentEye.addEventListener('click', function () {
                    if ($('#profile-customer-password').attr('type') === 'password') {
                        $('#profile-customer-password').attr('type', 'text');
                        this.classList.toggle('fa-eye');
                        this.classList.toggle('fa-eye-slash');
                    } else {
                        $('#profile-customer-password').attr('type', 'password');
                        this.classList.toggle('fa-eye');
                        this.classList.toggle('fa-eye-slash');
                    }
                });
            }
        });
    },
};
